import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  standalone: true,   // ✅ required since you bootstrap standalone
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('chatbot-client');

  private swUpdate = inject(SwUpdate);

  constructor() {
    this.swUpdate.versionUpdates.subscribe(() => {
      if (confirm('A new version is available. Reload now?')) {
        window.location.reload();
      }
    });
  }
}
